export default "__VITE_ASSET__bf8dfa64__"